import { BackupFile, SharingPermission } from '../service-proxies/api-service-proxies';

export class ShareDetails {
    file: BackupFile;
    share: SharingPermission;
    existingShares: SharingPermission[];
}